import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { Card, Group, Stack, Switch, Text } from "@mantine/core";
import { SwitchProps } from "@mantine/core/lib/Switch/Switch";

type Props = {
  inputProps: SwitchProps;
  disabled: boolean;
  chainSupportsERC20s: boolean;
  isSeries: boolean;
};

export const SponsoredMintsInput: React.FC<Props> = ({
  inputProps,
  disabled,
  chainSupportsERC20s,
  isSeries,
}) => {
  const enableSponsoredMints = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_SPONSORED_MINTS
  );
  if (!enableSponsoredMints) return <></>;
  return (
    <>
      <Stack spacing={0}>
        <Text size="sm" fw={500} component="label">
          Sponsored mints
        </Text>
        <Card p="xs" mt={8}>
          <Group position="apart" align="center" noWrap>
            <Stack spacing={0}>
              <Text size="sm">
                Make this collection available for sponsorship
              </Text>
              <Text size="sm" color={TEXT_COLOR.SECONDARY}>
                Only available for{isSeries ? " random" : ""} fixed price and
                free public sales{" "}
                {chainSupportsERC20s ? "not priced in an ERC20" : ""}
              </Text>
            </Stack>
            <Switch mt={4} {...inputProps} disabled={disabled} />
          </Group>
        </Card>
      </Stack>
    </>
  );
};
